import { Component, Input, OnInit, Renderer2, HostListener, ElementRef, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BodisplayService } from '../bodisplay';
import { BObjectModel, ConfigKey } from '../models';
import { CoreService } from '../services';
import { ToastService } from '../toast';
import { DialogService } from '../dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { b64EncodeUnicode } from '../utilities';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-insertdoc',
  templateUrl: './insertdoc.component.html',
  styleUrls: ['./insertdoc.component.css']
})
export class InsertdocComponent implements OnInit, AfterViewInit {

  public model: BObjectModel;  
  public tablette: boolean;
  public mobile: boolean;
  public maxUploadSize: string;
  public boHidden: boolean = false;

  public file: File | undefined;
  public eraseDocxFileIfNewDocIsPDF: boolean = false;
  @Input('item')
  set item(value: BObjectModel) {
    if (value !== null) {
      this.model = value;
    }
  }

  @Input('boHidden')
  set setBoHidden(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.boHidden = true;
    } else {
      this.boHidden = value;
    }
  }

  @Output() success: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event): void {
    this.setStyle();
  }


  constructor(
    private indParam: CoreService,
    private http: HttpClient,
    private render: Renderer2,
    private boservice: BodisplayService,
    private dialogservice: DialogService,
    private toastservice: ToastService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    //this.maxUploadSize = this.indParam.getConfigKey(ConfigKey.DOCSIZE);
    // Conversion octets en Mo pour l'affichage
    const sizeInMo: number = parseInt(this.indParam.getConfigKey(ConfigKey.DOCSIZE)) / 1000000;
    this.maxUploadSize = sizeInMo.toString();    
    this.file = undefined;
    this.mobile = window.innerWidth <= 1200 ? true : false;
  }
  ngAfterViewInit(): void {
    this.setStyle();
  }

  // #region FONCTIONS PUBLIQUES
 
  // Récupération des infos du bo pour l'upload
  public getEvent(model: BObjectModel): void {
    if (this.file !== undefined) {
      const fileName: string = b64EncodeUnicode(this.file.name);
      const ConfigFile: any = {
        responseType: 'arraybuffer' as 'arraybuffer',
        headers: { 'Queoval': this.indParam.AppParams.token, 'mode': 'INSERTDOC', 'fileName': fileName, 'IdDonnee': model.IdDonneeFils, 'IdRelation': model.IdRelation, 'GetIfExist': this.boHidden ? "1" : "0", 'eraseDocxFileIfNewDocIsPDF': this.eraseDocxFileIfNewDocIsPDF ? "1" : "0"}
      };
      const formData: FormData = new FormData();
      formData.append('file', this.file, fileName);
      formData.append('name', fileName);
      formData.append('IDDONNEE', model.IdDonneeFils);
      formData.append('IDRELATION', model.IdRelation);
      formData.append('ISCHILD', 'TRUE');
      formData.append('mode', 'INSERTDOC');
      formData.append('token', this.indParam.AppParams.token);

      this.http.post(`${this.indParam.AppParams.apiUrl}api/Upload`, formData, ConfigFile).subscribe((data: any) => {
        this.dialogservice.showSplash(false);        
        this.file = undefined;
        this.success.emit(true);
      },
        (error: any) => {
          this.toastservice.showAlertToast(`Une erreur est survenue lors de la sauvegarde de document`);
          this.dialogservice.showSplash(false);
          console.error(JSON.stringify(error));
          this.success.emit(false);
        }
      );
    } else {
      this.toastservice.showInfoToast(`Veuillez selectionner un document`);
      this.success.emit(false);
    }
  }

  //#endregion

  // #region FONCTIONS PRIVATE

  // Modifie le style en fonction de la taille du media
  setStyle(): void {
    this.mobile = window.innerWidth <= 1200;
  }
  // #endregion

}
